
import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  TextField,
  Paper,
  Typography,
  CircularProgress,
} from '@material-ui/core';
import Layout from './Layout';

export const Environment = () => {
  const [macAddress, setMacAddress] = useState('');
  const [envId, setEnvId] = useState('');
  const [responseData, setResponseData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isInputEmpty, setIsInputEmpty] = useState(false);


  const baseUrl =
    window.environment === 'dev'
      ? 'https://dev.phyfarm.com/'
      : 'https://v3.api.phyfarm.com/';

  const onSubmit = () => {

    if (!macAddress && !envId) {
      setIsInputEmpty(true);
      return;
    }

    setLoading(true);
    setIsInputEmpty(false);

    if (envId) {
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c',
        },
        body: JSON.stringify({
          envId: envId,
        }),
      };

      fetch(baseUrl + 'api/env/listEnvById', requestOptions)
        .then(response => response.json())
        .then(data => {
          console.log(data);
          setResponseData(data);
          setLoading(false);
        })
        .catch(error => console.log(error));
    }

    if (macAddress) {
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c',
        },
        body: JSON.stringify({
          macAddress: macAddress,
        }),
      };

      fetch(baseUrl + 'api/env/listEnv', requestOptions)
        .then(response => response.json())
        .then(data => {
          console.log(data);
          setResponseData(data);
          setLoading(false);
        })
        .catch(error => console.error(error));
    }

    if (!macAddress && !envId) {
      alert('Please Enter Mac Address or Env ID');
      setLoading(false);
    }
  };

  const handleDelete = item => {
    const deleteResponse = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c',
      },
      body: JSON.stringify({
        envID: item._id,
        rev: item._rev,
      }),
    };

    fetch(baseUrl + 'api/env/deleteEnv', deleteResponse)
      .then(deleteResponse => deleteResponse.json())
      .then(res => {
        onSubmit();
      })
      .catch(error => console.log(error));

    console.log(item);
  };

  return (
    <Layout>
      <div className="App">
        <Typography variant="h5" style={{ marginTop: 100 }}>
          List of Env - Mac Add. or Env Id
        </Typography>
        <form
          onSubmit={e => {
            e.preventDefault();
            onSubmit();
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: 40 }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <TextField
                label="MAC Address"
                value={macAddress}
                onChange={e => setMacAddress(e.target.value.trim())}
                variant="outlined"
                error={isInputEmpty && !macAddress}
                helperText={isInputEmpty && !macAddress ? 'Please enter MAC Address' : ''}
              />
            </div>

            <div style={{ display: 'flex', alignItems: 'flex-end', flexWrap: 'nowrap' }}>
              <Typography variant="subtitle1" style={{ color: '#777', margin: '12px 16px' }}>
                - OR -
              </Typography>
            </div>

            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <TextField
                label="ENV ID"
                value={envId}
                onChange={e => setEnvId(e.target.value.trim())}
                variant="outlined"
                error={isInputEmpty && !envId}
                helperText={isInputEmpty && !envId ? 'Please enter ENV ID' : ''}
              />
            </div>
          </div>
          <div>
            <Button
              style={{ margin: 20 }}
              type="submit"
              variant="contained"
              color="primary"
              disabled={loading}
            >
              Submit
            </Button>
          </div>
        </form>

        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', margin: '40px auto' }}>
            <CircularProgress />
          </div>
        ) : (
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center" style={{ fontWeight: 'bold' }}>
                    Env ID
                  </TableCell>
                  <TableCell align="center" style={{ fontWeight: 'bold' }}>
                    Mac Address
                  </TableCell>
                  <TableCell align="center" style={{ fontWeight: 'bold' }}>
                    Name
                  </TableCell>
                  <TableCell align="center" style={{ fontWeight: 'bold' }}>
                    Hardware
                  </TableCell>
                  <TableCell align="center" style={{ fontWeight: 'bold' }}>
                    Status
                  </TableCell>
                  <TableCell align="center" style={{ fontWeight: 'bold' }}>
                    Remove
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {responseData && responseData.data && Array.isArray(responseData.data.envs) && responseData.data.envs.length > 0 ? (
                  responseData.data.envs.map((item, index) => (
                    <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                      <TableCell align="center" component="th" scope="row">
                        {item._id}
                      </TableCell>
                      <TableCell align="center">{item.macAddress}</TableCell>
                      <TableCell align="center">{item.name}</TableCell>
                      <TableCell align="center">{item.hardware}</TableCell>
                      <TableCell align="center">
                        {item.online ? (
                          <span style={{ color: 'green' }}>TRUE</span>
                        ) : (
                          <span style={{ color: 'red' }}>FALSE</span>
                        )}
                      </TableCell>
                      <TableCell align="center">
                        <Button
                          variant="outlined"
                          color="secondary"
                          onClick={() => handleDelete(item)}
                        >
                          Delete
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell align="center" colSpan={6}>
                      {responseData &&
                        responseData.data &&
                        responseData.data.envs &&
                        responseData.data.envs.length === 0 ? (
                        <Typography variant="subtitle1">No data available.</Typography>
                      ) : null}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </div>
    </Layout>
  );
};
